import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    Plus,
    MoreHorizontal,
    Filter,
    Calendar,
} from 'lucide-react';

export default function Assignments() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 8');
    const [selectedDivision, setSelectedDivision] = useState('Division - C');

    const assignmentsData = [
        {
            sn: '01',
            id: 1,
            subject: "MATHEMATICS",
            title: "Algebra Variables & Equations",
            dueDate: "10 May 2026",
            submissions: "28/32",
            status: "Grading",
            color: 'text-amber-500 bg-amber-50/50'
        },
        {
            sn: '02',
            id: 2,
            subject: "PHYSICS",
            title: "Newton's Laws of Motion",
            dueDate: "12 May 2026",
            submissions: "30/32",
            status: "Completed",
            color: 'text-emerald-500 bg-emerald-50/50'
        },
        {
            sn: '03',
            id: 3,
            subject: "CHEMISTRY",
            title: "Periodic Table & Elements",
            dueDate: "15 May 2026",
            submissions: "15/32",
            status: "Active",
            color: 'text-blue-500 bg-blue-50/50'
        }
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Academic Assignments"
                    subtitle={`Monitor and grade student submissions for ${selectedStandard}`}
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >
                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        New Task
                    </button>
                </Header>

                {/* Main Content Table Card */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">Assignment Tracker</h3>
                            <div className="flex items-center gap-4">
                                <span className="bg-amber-50 text-amber-600 px-3 py-1 rounded-lg text-[12px] font-black">12 To Grade</span>
                                <span className="text-gray-400 font-bold text-[14px]">Total 24 Published</span>
                            </div>
                        </div>
                        <div className="flex items-center gap-6">
                            <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50">
                                <Filter size={18} className="text-gray-400" />
                                Filter
                            </button>
                            <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                                <MoreHorizontal size={22} />
                            </button>
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">S/N</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Subject & Title</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Submissions</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">Deadline</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {assignmentsData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5 text-[14px] font-bold text-gray-500 text-center">{v.sn}</td>
                                        <td className="px-6 py-5">
                                            <div className="flex flex-col gap-0.5">
                                                <p className="text-[11px] font-black text-blue-500 tracking-widest uppercase">{v.subject}</p>
                                                <p className="text-[16px] font-black text-[#111827] group-hover:text-blue-500 transition-colors leading-tight">{v.title}</p>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-3">
                                                <div className="flex-1 max-w-[100px] h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                                    <div className="h-full bg-blue-500 rounded-full" style={{ width: `${(eval(v.submissions)) * 100}%` }}></div>
                                                </div>
                                                <span className="text-[14px] font-black text-[#111827]">{v.submissions}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-[14px] font-bold text-gray-600 text-center">
                                            <div className="flex items-center justify-center gap-2">
                                                <Calendar size={14} className="text-gray-400" />
                                                {v.dueDate}
                                            </div>
                                        </td>
                                        <td className="px-8 py-5 text-center">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg inline-block text-center uppercase tracking-widest ${v.color}`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <button className="px-4 py-2 bg-slate-50 text-slate-500 rounded-lg text-[12px] font-black hover:bg-blue-50 hover:text-blue-600 transition-all">
                                                    Evaluate
                                                </button>
                                                <button className="p-2 text-gray-400 hover:text-gray-900 transition-colors">
                                                    <MoreHorizontal size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-8 border-t border-gray-50 flex items-center justify-between">
                        <div className="flex items-center gap-2 text-[14px] font-bold text-gray-400">
                            Total 24 assignments across all classes
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
